import { User } from 'lucide-react';

const PlayerFilter = ({ selectedPlayer, setSelectedPlayer, players }) => {
  return (
    <div className="flex items-center gap-3">
      <User className="w-4 h-4 text-zinc-400" />
      <select
        value={selectedPlayer}
        onChange={e => setSelectedPlayer(e.target.value)}
        className="text-sm border border-zinc-200 rounded px-3 py-1.5 bg-white text-zinc-700 focus:outline-none focus:ring-2 focus:ring-zinc-400 focus:border-transparent"
      >
        <option value="all">All Players</option>
        {players
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(player => (
            <option key={player.id} value={player.id}>
              {player.name}
            </option>
          ))}
      </select>
    </div>
  );
};

export default PlayerFilter;
